import React from 'react';
import styled from 'styled-components';
import { MenuItem } from '../Layout';
import { SubMenu } from './SubMenu';

type Props = { menuItem: MenuItem };
export const FloatingSubMenu: React.FC<Props> = ({ menuItem }) => {
  return (
    <Floating>
      <div>
        <SubMenu />
      </div>
    </Floating>
  );
};

const Floating = styled.div`
  position: absolute;
  min-width: 30rem;
  width: 100%;

  > :first-child {
    background-color: ${({ theme }) => theme.colors.white};
    position: relative;
    z-index: 2;
    padding: 1.875rem;
  }
`;
